import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RecaptchaService {

  constructor(private http: HttpClient) { }

  private controllerName = '/api/Recaptcha';
  private headers = { headers: { 'Content-Type': 'application/json' } };

  verify(token: string): Observable<any> {
    let tokenObj = {
      value: token
    }

    return this.http.post(`${this.controllerName}/VerifyRecaptchaAsync`, JSON.stringify(tokenObj), this.headers);
  };
  }
